/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/AddAPhoto';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const AddAPhotoIcon = withMuiAdapter(Base, 'AddAPhoto');
